import React from 'react'
import 'dayjs/locale/es'

import { Card, Table, Text } from '@mantine/core';
import CustomerRow from './CustomerRow';

const CustomersTable = ({ items, onOpen, openConfirm, openRecordModal, _openManualRenovation }) =>
{
  return (
    <Card shadow="md" p={0} radius="lg" withBorder mx="md" className='w-full overflow-hidden'>
      <Table.ScrollContainer minWidth={ 800 }>
        <Table verticalSpacing="sm">
          <Table.Thead bg="gray.0">
            <Table.Tr>
              <Table.Th px="md" py="md"><Text size="xs" fw={700} c="dimmed"># CUENTA</Text></Table.Th>
              <Table.Th align="left"><Text size="xs" fw={700} c="dimmed">NOMBRE DEL CLIENTE</Text></Table.Th>
              <Table.Th align="center"><Text size="xs" fw={700} c="dimmed">PRÓX. FACTURACIÓN</Text></Table.Th>
              <Table.Th align="center"><Text size="xs" fw={700} c="dimmed">FECHA LÍMITE</Text></Table.Th>
              <Table.Th></Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            { items && items.length > 0 ? (
              items.map((item) => (
                <CustomerRow 
                  key={item._id}
                  item={ item } 
                  onOpen={ onOpen } 
                  openConfirm={ openConfirm } 
                  openRecordModal={openRecordModal} 
                  _openManualRenovation={_openManualRenovation}
                />
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={5} align="center" py="xl">
                  <Text c="dimmed" size="sm">No se encontraron clientes con esos criterios.</Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  )
}

export default CustomersTable
